import { formatTicker } from '@api';
import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { EllipsisDetector } from '@terminal/components/ellipsis-detector/EllipsisDetector';
import { useEntity } from '@terminal/react-query-hooks/entities/useEntities';

import styles from './EntityCell.module.scss';

export const EntityCell = ({ entityTag }: { entityTag: string }) => {
  const { data, isFetching, isError } = useEntity(entityTag);

  if (isFetching) {
    return (
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '100%',
              height: '36px',
              borderRadius: '8px',
            },
          },
        ]}
      />
    );
  }

  if (isError || !data?.data) {
    return null;
  }

  const formattedTicker = formatTicker(data.data);
  const name = data.data.name_short || data.data.name;

  return (
    <div className={styles.root} data-testid="entity-cell">
      <AssetLogoContainer entity={data.data} size={28} />
      <div className={styles.flexColumn}>
        <EllipsisDetector label={name}>
          <div className={styles.titleLabel}>{name}</div>
        </EllipsisDetector>
        <div className={styles.tickerLabel}>{formattedTicker}</div>
      </div>
    </div>
  );
};
